import PropTypes from 'prop-types';
import React from 'react';
import { Button, ButtonToolbar } from 'react-bootstrap';
import EmailForm from '../../../forms/EmailForm';
import AgencyEditModal from './AgencyEditModal';

class AgentSendMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showInvite: false,
      showEdit: false,
    };
    this.closeEdit = this.closeEdit.bind(this);
    this.openEdit = this.openEdit.bind(this);
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  closeEdit() {
    this.setState({ showEdit: false });
  }
  openEdit() {
    this.setState({ showEdit: true });
  }
  close() {
    this.setState({ showInvite: false });
  }
  open() {
    this.setState({ showInvite: true });
  }
  handleSubmit(values) {
    const payload = values;
    payload.agency = this.props.id;
    this.props.sendAgentInvite(
      payload,
    );
    this.close();
  }
  render() {
    return (
      <div>
        <ButtonToolbar className="agency-toolbar">
          <Button
            bsStyle="success"
            onClick={this.open}
          >
            <i
              className="fa fa-envelope"
              aria-hidden="true"
            /> Add New Agent
          </Button>
          <Button
            bsStyle="default"
            onClick={this.openEdit}
          >
            <i
              className="fa fa-pencil"
              aria-hidden="true"
            /> Edit
          </Button>
        </ButtonToolbar>
        {this.state.showInvite && (
        <div>
          <div className="agency-emailForm">
            <h3>Invite Agent</h3>
            <p>Add new team members by inviting them here.</p>
            <EmailForm
              onSubmit={this.handleSubmit}
              cancel={this.close}
            />
          </div>
        </div>
        )}
        {this.state.showEdit && (
          <AgencyEditModal
            show={this.state.showEdit}
            onClose={this.closeEdit}
            agency={this.props.agency}
            editAgency={this.props.editAgency}
          />
        )}
      </div>
    );
  }
}

AgentSendMenu.propTypes = {
  id: PropTypes.number.isRequired,
  sendAgentInvite: PropTypes.func.isRequired,
};

export default AgentSendMenu;



// WEBPACK FOOTER //
// src/routes/agency/components/AgentSendMenu.js